'use strict';

var _extends = require('@babel/runtime/helpers/extends');

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');

var _createClass = require('@babel/runtime/helpers/createClass');

var _inherits = require('@babel/runtime/helpers/inherits');

var _possibleConstructorReturn = require('@babel/runtime/helpers/possibleConstructorReturn');

var _getPrototypeOf = require('@babel/runtime/helpers/getPrototypeOf');

var React = require('react');

var injectSheet = require('react-jss');

var THEME = require('pobble-components/dist/theme');

var PropTypes = require('prop-types');

var classNames = require('classnames');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _extends__default =
/*#__PURE__*/
_interopDefaultLegacy(_extends);

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var _objectWithoutProperties__default =
/*#__PURE__*/
_interopDefaultLegacy(_objectWithoutProperties);

var _classCallCheck__default =
/*#__PURE__*/
_interopDefaultLegacy(_classCallCheck);

var _createClass__default =
/*#__PURE__*/
_interopDefaultLegacy(_createClass);

var _inherits__default =
/*#__PURE__*/
_interopDefaultLegacy(_inherits);

var _possibleConstructorReturn__default =
/*#__PURE__*/
_interopDefaultLegacy(_possibleConstructorReturn);

var _getPrototypeOf__default =
/*#__PURE__*/
_interopDefaultLegacy(_getPrototypeOf);

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var injectSheet__default =
/*#__PURE__*/
_interopDefaultLegacy(injectSheet);

var THEME__default =
/*#__PURE__*/
_interopDefaultLegacy(THEME);

var PropTypes__default =
/*#__PURE__*/
_interopDefaultLegacy(PropTypes);

var classNames__default =
/*#__PURE__*/
_interopDefaultLegacy(classNames);

var COLORS = THEME__default["default"].COLORS;
var styles = {
  radioContainer: {
    position: 'relative',
    width: '20px',
    height: '20px',
    display: 'inline-block'
  },
  disabled: {
    '& $radioBG': {
      backgroundColor: '#DFDFDF',
      borderColor: '#C9C9C9'
    },
    '& $mark': {
      backgroundColor: '#DFDFDF',
      borderColor: '#C9C9C9'
    }
  },
  radioButton: {
    width: '20px',
    height: '20px',
    border: 'none',
    opacity: '0',
    cursor: 'pointer',
    '&:checked + span': {
      '& > span': {
        opacity: '1',
        transform: 'scale(1)'
      }
    }
  },
  radioBG: {
    position: 'absolute',
    pointerEvents: 'none',
    left: '0',
    top: '0',
    width: '20px',
    height: '20px',
    border: '1px solid #dedede',
    backgroundColor: '#fafafa',
    borderRadius: '100%',
    display: 'inline-block',
    cursor: 'pointer',
    '& *': {
      pointerEvents: 'none'
    }
  },
  mark: {
    display: 'block',
    transform: 'scale(0.1)',
    transition: 'transform 350ms cubic-bezier(0.38, 0.57, 0.57, 1.62), opacity 250ms ease-in',
    opacity: '0',
    width: '12px',
    height: '12px',
    border: "1px solid ".concat(COLORS.BLUE.NORMAL),
    backgroundColor: COLORS.BLUE.EXTRA_FADED,
    borderRadius: '100%',
    padding: '2px',
    margin: '3px 0 0 3px',
    '& svg': {
      color: '#fff',
      width: '14px'
    }
  }
};
var _excluded = ["classes", "name", "id", "checked", "onChange", "value", "radioProps", "disabled"];

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn__default["default"](this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FormRadio =
/*#__PURE__*/
function (_Component) {
  _inherits__default["default"](FormRadio, _Component);

  var _super = _createSuper(FormRadio);

  function FormRadio() {
    _classCallCheck__default["default"](this, FormRadio);

    return _super.apply(this, arguments);
  }

  _createClass__default["default"](FormRadio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          name = _this$props.name,
          id = _this$props.id,
          checked = _this$props.checked,
          onChange = _this$props.onChange,
          value = _this$props.value,
          radioProps = _this$props.radioProps,
          disabled = _this$props.disabled,
          props = _objectWithoutProperties__default["default"](_this$props, _excluded);

      return (
        /*#__PURE__*/
        React__default["default"].createElement("span", {
          className: classNames__default["default"](classes.radioContainer, _defineProperty__default["default"]({}, classes.disabled, disabled))
        },
        /*#__PURE__*/
        React__default["default"].createElement("input", _extends__default["default"]({
          disabled: disabled,
          checked: checked,
          onChange: onChange,
          value: value,
          name: name,
          id: id,
          type: "radio",
          className: classes.radioButton
        }, radioProps, props)),
        /*#__PURE__*/
        React__default["default"].createElement("span", {
          className: classes.radioBG
        },
        /*#__PURE__*/
        React__default["default"].createElement("span", {
          className: classes.mark
        })))
      );
    }
  }]);

  return FormRadio;
}(React.Component);

FormRadio.propTypes = {
  /** Id of the radio button DOM node */
  id: PropTypes__default["default"].string,

  /** Name of the radio button DOM node */
  name: PropTypes__default["default"].string,

  /** Boolean value of checked state. Makes radio button controlled */
  checked: PropTypes__default["default"].bool,

  /** On radio button status change handler */
  onChange: PropTypes__default["default"].func,

  /** Additional className if you want to restyle component */
  className: PropTypes__default["default"].string,

  /** Object with all additional radio props you want to pass. Check official radio documentation to get the idea what props os available */
  radioProps: PropTypes__default["default"].object
};
var index = injectSheet__default["default"](styles)(FormRadio);
module.exports = index;